import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { get as _get, set as _set, isNil as _isNil } from 'lodash';
import { BaseRequester } from 'src/app/shared/services/common/base-requester';
import { UnifiedQueryRequestV2 } from 'src/app/shared/services';

@Injectable({
    providedIn: 'root',
})
export class PriceCalSaveService extends BaseRequester {
    constructor() {
        super();
    }

    save(saveReq: PriceCalSaveRequest) {
        return this.internalPostRequest<PriceCalSaveRequest>(
            environment.priceCalSaveEndpoint,
            saveReq,
        ).pipe(
            map((response) => {
                // The save Lambda resolves exactly `true` on success (and
                // rejects on failure, which surfaces as an HTTP error handled
                // by the caller's error callback). It never returns `false`,
                // so any non-`true` body means the save did not succeed.
                return _get(response, 'response') === true;
            }),
        );
    }

    load(pid: number) {
        return this.internalPostRequest<UnifiedQueryRequestV2>(
            environment.unifiedQueryV2EndPoint,
            {
                db: 'management-console',
                col: 'price_cal_params',
                query: {
                    pid: { $in: [pid, -1] },
                },
                options: {
                    projection: { _id: 0 },
                },
            },
        ).pipe(
            map((response) => {
                const responseItems = _get(response, 'response');
                let result = { pid: pid };
                for (const item of responseItems) {
                    const key = _get(item, 'key', '');
                    const value = _get(item, 'value', '');
                    if (!_isNil(key) && !_isNil(value)) {
                        result = _set(result, item.key, item.value);
                    }
                }
                return result;
            }),
        );
    }
}

interface PriceCalSaveRequest {
    pid: number;
    params: object;
}
